import { OrderTrackingShipmentStatus } from "./order-tracking-types";
import type {
  TrackingPageOrder,
  TrackingPageShipment,
} from "./tracking-page-order-definition";

/**
 * Hide cancelled fulfillments: their items re-ship under a new fulfillment or
 * rejoin the "not yet shipped" pool. If all are cancelled, keep the raw list.
 */
export function getVisibleShipments(
  shipments: TrackingPageShipment[],
): TrackingPageShipment[] {
  const active = shipments.filter(
    (shipment) =>
      shipment.status !== OrderTrackingShipmentStatus.SHIPMENT_CANCELLED,
  );
  return active.length === 0 || active.length === shipments.length
    ? shipments
    : active;
}

export function withVisibleShipments(
  order: TrackingPageOrder,
): TrackingPageOrder {
  const visible = getVisibleShipments(order.shipments);
  return visible === order.shipments ? order : { ...order, shipments: visible };
}
